/*
 * Name: Current Party
 * Component: global
 * Props:
 */
import React from "react"
import PartyListModal from "../../party/PartyListModal/PartyListModal"
import * as styles from "./CurrentParty.module.scss"
import AuthenticationModal from "@components/auth/AuthenticationModal/AuthenticationModal"
import switchBlue from "@images/icons/switchBlue.svg"

const CurrentParty = (props) => {
  const classes = `${styles.CurrentParty} ${styles[props.color]} ${props.className}`

  const saveParty = !props.isMobile ? (
    <div
      className={`${styles.NoParty} ${props.className} ${
        props.currentSearchCategory || (props.currentParty && props.currentParty.partyCategoryData) ? styles.active : ""
      }`}
    >
      <AuthenticationModal
        defaultStep="createParty"
        button={{ text: "Save Party", design: "solid", color: "pink" }}
      />
    </div>
  ) : null

  return props.currentParty && props.currentParty.partyId ? (
    <div className={classes}>
      <PartyListModal
        currentParty={props.currentParty}
        button={{
          image: switchBlue,
          design: "linkStyle",
          imageRight: true,
          text: `Saving To: ${props.currentParty.partyName}`,
        }}
      />
    </div>
  ) : (
    saveParty
  )
}

export default CurrentParty
